import React from 'react';
import PropTypes from 'prop-types';
import { Button } from 'semantic-ui-react';
import Call from '../Call';
import Location from '../Location';
import Email from '../Email';
import './ContactRail.css';

export default class ContactRail extends React.Component {
  renderCallToAction(type, props) {
    const { buttonColor, iconsOnly } = this.props;
    const manifestation = iconsOnly ? 'icon' : 'button';

    if (type === 'call') {
      return (
        <Call
          className="contact-rail-item"
          key={type}
          as={manifestation}
          buttonColor={buttonColor}
          showIcon
          {...props}
        />
      );
    }

    if (type === 'location') {
      return (
        <Location
          className="contact-rail-item"
          key={type}
          as={manifestation}
          buttonText={iconsOnly ? '' : 'Find us on Google Maps'}
          buttonColor={buttonColor}
          {...props}
        />
      );
    }

    if (type === 'email') {
      return (
        <Email
          className="contact-rail-item"
          key={type}
          as={manifestation}
          buttonColor={buttonColor}
          showIcon
          {...props}
        />
      );
    }

    return <div />;
  }

  render() {
    const { vertical, items, grouped } = this.props;

    return grouped ? (
      <Button.Group vertical={vertical} style={{ borderRadius: '0em' }}>
        {items.map(({ type, props }) => this.renderCallToAction(type, props))}
      </Button.Group>
    ) : (
      <div>
        {vertical
          ? items.map(({ type, props }) => (
              <div key={type} style={{ marginBottom: '0.25em' }}>
                {this.renderCallToAction(type, props)}
              </div>
            ))
          : items.map(({ type, props }) => this.renderCallToAction(type, props))}
      </div>
    );
  }
}

ContactRail.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      type: PropTypes.oneOf(['call', 'location', 'email']),
      props: PropTypes.object,
    }),
  ).isRequired,
  buttonColor: PropTypes.string,
  circular: PropTypes.bool,
  grouped: PropTypes.bool,
  iconsOnly: PropTypes.bool,
  vertical: PropTypes.bool,
};

ContactRail.defaultProps = {
  buttonColor: 'primary',
  circular: false,
  grouped: false,
  iconsOnly: false,
  vertical: false,
};
